
import { defineComponent, PropType } from "vue";
export default defineComponent({
  name: "MapInput",
  props: {
    input: { type: Object as PropType<any>, required: true },
    values: { type: Object as PropType<Record<string, any>>, required: true },
  },
});
